import React from 'react';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import Box from '@mui/material/Box';
import { Link as RouterLink } from 'react-router-dom';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import CardMaster from 'components/Product/CardMaster';
import striptags from 'striptags';
import { oneSentence } from 'lib/misc';
import { isMobileOrTablet } from 'utilities/userAgent';
import { cgtag } from '../../utilities/gtag';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { shopifyExtractId } from 'lib/shopifyHelpers';

interface SearchCollectionsProps {
  title?: string;
  collections: any;
  hasDivider?: boolean;
  sx?: SxProps<Theme>;
  pathName?: 'collection' | 'product';
  showPlaceholder?: boolean;
  onClose?: () => void;
}

const SearchCollections: React.FC<SearchCollectionsProps> = ({ title, collections, hasDivider = true, sx, pathName = 'product', showPlaceholder = false, onClose }) => {
  return (
    <>
      {title && <Box sx={{ pl: { sm: 2 }, typography: 'subtitle1', color: 'text.secondary' }}>{title}</Box>}
      <List sx={{ mb: 4 }}>
        {
          // @ts-ignore
          collections &&
            collections.map((product: any, idx: number) => (
              <ListItem
                key={idx}
                sx={{
                  py: 3,
                  px: { xs: 0, sm: pathName === 'collection' ? 0 : 2 },
                  ...sx,
                }}
                divider={hasDivider && !isMobileOrTablet()}
                button
                component={RouterLink}
                to={`/${pathName}/` + product.handle}
                onClick={() => {
                  cgtag('select_content', {
                    content_type: pathName,
                    item_id: shopifyExtractId(product.id.toString()),
                    item_name: product.title,
                  });
                  if (onClose) onClose();
                }}
              >
                {(product.featured_image.url || showPlaceholder) && (
                  <ListItemAvatar sx={{ minWidth: { xs: 110, sm: 212 } }}>
                    <Box sx={{ maxWidth: { xs: 100, sm: 180 } }} display="flex">
                      <CardMaster noButton size="small" image={product.featured_image.url} />
                    </Box>
                  </ListItemAvatar>
                )}
                <ListItemText
                  primary={product.title}
                  primaryTypographyProps={{
                    variant: 'subtitle2',
                  }}
                  secondary={oneSentence(striptags(product.body).replace(/\[.*]/g, ''))}
                  secondaryTypographyProps={{
                    variant: 'body1',
                  }}
                  sx={{
                    maxWidth: '450px',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                  }}
                />
              </ListItem>
            ))
        }
      </List>
    </>
  );
};

export default SearchCollections;
